import { InvoicePaymentUpsertAction } from 'components/InvoicePayment/actions';
import { type AppDispatch } from 'store';
import { formatAsCurrencyInternal, type FormatAsCurrencyType } from 'utils/formatters';
import type { TxnOptionProps } from './types';

type ApplyPaymentSubmenuProps = {
  recordPayment: boolean;
  availableCredit: number;
  txnId: string | null | undefined;
  dispatch: AppDispatch;
  formatAsCurrency: FormatAsCurrencyType | undefined;
} & Pick<TxnOptionProps, 'closeMenu' | 'context'>;

export const buildApplyPaymentSubmenu = ({
  recordPayment,
  availableCredit,
  closeMenu,
  context,
  txnId,
  dispatch,
  formatAsCurrency = formatAsCurrencyInternal,
}: ApplyPaymentSubmenuProps) => {
  return [
    {
      label: 'Link to Transaction',
      value: 'link-to-transaction',
      subtext: 'Choose from one of your downloaded transactions ',
      onSelect: () => {
        closeMenu();
        dispatch(
          InvoicePaymentUpsertAction({
            action: recordPayment ? 'RECORD_PAYMENT' : 'RECORD_REFUND',
            context,
            initIdType: 'INVOICE',
            initId: txnId,
            initScreen: 'SELECTION',
          }),
        );
      },
    },
    {
      label: 'Create Transaction',
      value: 'create-manual-txn',
      subtext: recordPayment ? 'Create and apply a payment' : 'Create and apply a refund',
      onSelect: () => {
        closeMenu();
        dispatch(
          InvoicePaymentUpsertAction({
            action: recordPayment ? 'RECORD_PAYMENT' : 'RECORD_REFUND',
            context,
            initIdType: 'INVOICE',
            initId: txnId,
            initScreen: 'MAIN',
          }),
        );
      },
    },
    ...(recordPayment
      ? [
          {
            label: 'Use Existing Credit',
            value: 'apply-existing-credit',
            subtext: `Client credit balance is ${formatAsCurrency(availableCredit)}`,
            disabled: !availableCredit || availableCredit < 0.005,
            onSelect: () => {
              closeMenu();
              dispatch(
                InvoicePaymentUpsertAction({
                  action: 'ASSIGN_CREDITS',
                  context,
                  initIdType: 'INVOICE',
                  initId: txnId,
                  initScreen: 'MAIN',
                }),
              );
            },
          },
        ]
      : []),
  ];
};
